<script>
	import { afterUpdate } from "svelte";

	function pageLookup() {
		let page;
		const urlParams = new URLSearchParams(window.location.search);
		const searchPage = urlParams.get('page');
		if (!searchPage) {
			page = 'main'
		} else { 
			page = searchPage;
		}

		const entries = {
			main: '<a href="./index.html?page=main">Home Page</a>',
			vne: '<a href="./index.html?page=vne">View New Entries</a>',
			dialogue: '<a href="./dialogue_builder.php">Dialogue Builder</a>',
			interwikis: '<a href="./interwikis.php">Interwikis</a>',
		}

		if (!Object.keys(entries).includes(page)) return;
		
		const localEntries = entries;
		delete localEntries[page];

		const nav = document.getElementById('top_nav').getElementsByTagName('p')[0];
		nav.innerHTML = Object.values(localEntries).join(' &#8226 ') + '<br/>' + nav.innerHTML;
	}
	afterUpdate( () => pageLookup());
</script>


<nav id='top_nav'>
	<p>
		<a href="http://wiki.guildwars2.com/wiki/User:Darqam/GW2W_Easy_Mode">Project Information</a> &#8226 <a href="http://wiki.guildwars2.com/wiki/User_talk:Darqam/GW2W_Easy_Mode">Contact Me On Wiki</a>
	</p>
</nav>

<style>
	p {
		text-align: center;
	}
</style>